import { render, staticRenderFns } from "./DIASRealEstateActions.vue?vue&type=template&id=c43152d4&"
import script from "./DIASRealEstateActions.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateActions.vue?vue&type=script&lang=js&"
import style0 from "./DIASRealEstateActions.vue?vue&type=style&index=0&id=c43152d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports